import './App.scss';
import React from 'react';
import {
  Route,
  withRouter,
} from "react-router-dom";
import Nav, { routes } from './nav/Nav';
import { getMediaQuery, MediaQueryContext } from './MediaQueryContext';
import { CSSTransition } from 'react-transition-group';
import { getScrollingEl } from 'helpers/getScrollingEl/getScrollingEl';

class App extends React.Component {

  constructor(props) {
    super(props);
    let currentBackgroundSettings = routes.find(route => route.path === this.props.location.pathname) || {};

    this.state = { mediaQuery: getMediaQuery(), backgroundSettings: currentBackgroundSettings || {} };
    this.onRouteChanged = this.onRouteChanged.bind(this)
    this.mediaQueryListnener = this.mediaQueryListnener.bind(this)
  }

  componentDidMount() {
    window.addEventListener("resize", this.mediaQueryListnener);

  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.mediaQueryListnener);


  }


  mediaQueryListnener(e) {
    let mediaQuery = getMediaQuery();
    this.setState({ mediaQuery });
  }

  componentDidUpdate(prevProps) {

    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    let currentBackgroundSettings = routes.find(route => route.path === this.props.location.pathname) || {};
    setTimeout(() => this.setState({ backgroundSettings: currentBackgroundSettings }), 1000)

    // Scroll back to the top
    let scrollingEl = getScrollingEl();
    scrollingEl.scrollTo(0, 0);
  }

  setBackgroundImage(image) {
    this.setState({ backgroundSettings: { backgroundImage: image } })
  }

  render() {
    return (
      <MediaQueryContext.Provider value={this.state.mediaQuery}>

        <div className="App">

          <header className="App-header">
            <Nav />
          </header>
          <div className="app-body" style={this.state.backgroundSettings}>

            {routes.map(({ path, Component }) => {

              return (
                <Route key={path} exact path={path}>
                  {({ match }) => (
                    <CSSTransition
                      in={match != null}
                      timeout={3000}
                      classNames="route-transition"
                      unmountOnExit
                      appear
                    >
                      <Component setBackgroundImage={this.setBackgroundImage.bind(this)} />
                    </CSSTransition>
                  )}
                </Route>
              );
            })}






          </div>


        </div>
      </MediaQueryContext.Provider>
    );
  }
}

export default withRouter(App);
